import React from 'react';
import {TaskRowHeaderV2 as TaskRowHeaderComponentV2} from '@/web-components';
import * as tracking from '../../../../../tracking';
import {hasFeatureFlag} from '../../../util/FeatureUtil';

const TaskListHeader = ({intl, enabledColumns, sortBy, onSortByChange, stickyTopPosition, isInContainer}) => {
	return (
		<TaskRowHeaderComponentV2
			intl={intl}
			columns={enabledColumns}
			sortBy={sortBy}
			onSortByChange={onSortByChange}
			stickyTopPosition={stickyTopPosition}
			isInContainer={isInContainer}
			tracking={tracking}
			showNovaColumn={hasFeatureFlag('nova_agent_invocation')}
		/>
	);
};

export default TaskListHeader;
